import React, { Component } from 'react'

// ui
import {
    Form,
    Input,
    Switch,
    Upload,
    Icon,
    message,
    Avatar,
    Tag,
    Menu,
    Popover,
    Tooltip,
    Dropdown,
    Select,
} from 'antd'
import { FaTimes, FaPlus, FaSave, FaFileAlt } from 'react-icons/fa'
import Button from '../../../components/uielements/button'
import Editor from '../../../componentIsoMophic/ScrumBoard/Editor/editor'
import defaulObject from '../../../resource/image/objectDefault.png'
import ButtonMaterial from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
// sub component
import ListComment from './list_comments'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'
import defaultEvent from '../../../resource/image/imgEventDefaul.jpg'
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const defaultAvatar = require('../../../resource/image/defaultAvatar.png')

class ReportInfoForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tagMenuVisible: false,
            selected_Media: this.props.selected_Media,
            current_hashtag: '',
            open: false,
            tierID: 0
        }
    }

    componentWillReceiveProps = nextProps => {
        // select
        if (nextProps.selected_Media !== this.state.selected_Media)
            this.setState({ selected_Media: nextProps.selected_Media })
        if (nextProps.selected_object !== this.state.selected_object)
            this.setState({ selected_object: nextProps.selected_object })
        if (nextProps.selected_event !== this.state.selected_event)
            this.setState({ selected_event: nextProps.selected_event })
        if (nextProps.selected_report !== this.state.selected_report)
            this.setState({ selected_report: nextProps.selected_report })
        if (nextProps.hashtag !== this.state.hashtag)
            this.setState({ hashtag: nextProps.hashtag })

        // report data
        if (nextProps.report !== this.props.report) {
            const { form, report } = nextProps

            form.setFieldsValue({ title: report.title })
        }
    }

    componentDidMount = () => {
        const { form, report } = this.props

        form.setFieldsValue({ title: report.title })
    }

    // event
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            const { report } = this.props

            if (report.title === '') {
                message.error('Tiêu đề không để trống')
                return
            }

            const content = report.content.trim()
            console.log('Noi dung: ', content)
            // return

            if (
                content === '' ||
                content === '<p></p>' ||
                content === null ||
                content === '<p><br></p>'
            ) {
                message.error('Nội dung không được để trống')
                return
            }

            if (!err) {
                this.props.dismiss()
                this.props.saveCurrentReport()
            }
        })
    }

    _handleSendReport = e => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.sendCurrentReport()
                this.props.dismiss()
            }
        })
    }

    // handle
    tagMenuHide = () => {
        this.setState({
            tagMenuVisible: false,
            current_hashtag: '',
            select_hashtag: '',
        })
    }

    _handleTagMenuVisibleChange = visible => {
        this.setState({ tagMenuVisible: visible })
    }

    // render
    _handleCurrentHashTagChange = e => {
        let value = e.target.value
        this.setState({ current_hashtag: value })
    }

    _handleAddHashTag = () => {
        let value = this.state.current_hashtag
        if (value === '') return

        this.props.addHashTag(value)
        this.tagMenuHide()
    }

    handleClickOpen = (id) => {
        this.setState({ open: true, tierID: id })
    }
    handleClose = () => {
        this.setState({ open: false })
    }
    handleChangeTierID = () => {
        console.log('change tier id')
        this.props.updateCurentReport({
            tier_created: this.state.tierID,
        })
        this.props.updateSelectedReport([])
        this.setState({ open: false })
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const {
            selected_Media,
            selected_object,
            selected_event,
            selected_report,
            hashtag,
        } = this.state
        const { report, user_has_read, is_select_report_tier } = this.props

        const visible_button_send_report = report.fid === 0

        let renderMenuHashtag = (
            <div>
                <div style={{ marginBottom: 10 }}>
                    <span style={{ marginRight: 5 }}>Hashtag</span>
                    <Input
                        placeholder="Nhập hashtag"
                        maxLength={25}
                        style={{ width: 200 }}
                        onChange={e => this._handleCurrentHashTagChange(e)}
                        value={this.state.current_hashtag}
                        onPressEnter={() => this._handleAddHashTag()}
                    />
                </div>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this._handleAddHashTag()}
                        style={{ marginLeft: 80 }}
                    >
                        Thêm
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => this.tagMenuHide()}
                        style={{ marginLeft: 10 }}
                    >
                        Huỷ
                    </Button>
                </div>
            </div>
        )

        let renderDeleteHashTag = (
            <Menu>
                <Menu.Item
                    onClick={() =>
                        this.props.deleteHashTag(this.state.select_hashtag)
                    }
                >
                    Xoá
                </Menu.Item>
            </Menu>
        )

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        }

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                <Form.Item label="Tiêu đề" hasFeedback>
                    <Input
                        onChange={e => {
                            this.props.updateCurentReport({
                                title: e.target.value,
                            })
                        }}
                        value={report.title}
                    />
                </Form.Item>
                <Form.Item label="Tier báo cáo">
                    {is_select_report_tier ? (
                        <Select
                            value={report.tier_created}
                            onChange={value => {
                                if (this.props.selected_report && this.props.selected_report.length > 0) {
                                    this.handleClickOpen(value)
                                } else {
                                    this.props.updateCurentReport({
                                        tier_created: value,
                                    })
                                }

                            }

                            }
                        >
                            {[1, 2, 3].map((tier_id, index) => {
                                return (
                                    <Select.Option key={index} value={tier_id}>
                                        {'Tier ' + tier_id}
                                    </Select.Option>
                                )
                            })}
                        </Select>
                    ) : (
                            <div>{'Tier ' + report.tier_created}</div>
                        )}
                </Form.Item>
                <Form.Item label="Người tạo">
                    <Avatar
                        src={report.owner && report.owner.avatar !== '' ? report.owner.avatar : defaultAvatar}
                        alt="Avatar"
                    />
                    <span style={{ color: 'black', marginLeft: 5 }}>
                        {report.owner ? report.owner.display_name : ''}
                    </span>
                </Form.Item>
                <Form.Item label="Căn cứ">
                    <div>
                        <div>
                            {Array.isArray(selected_report) &&
                                selected_report.map((data, index) => {
                                    return (
                                        <div key={index}>
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={`/app/qbreport/${data.fid}`}
                                                style={{
                                                    padding: 5,
                                                    cursor: 'pointer',
                                                    color: 'black',
                                                }}
                                            >
                                                <FaFileAlt /> {data.title}
                                            </a>
                                        </div>
                                    )
                                })}
                        </div>
                        <div>
                            <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                icon="select"
                                onClick={() =>
                                    this.props.showModalSelectReportLowerTier()
                                }
                            ></Button>
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Sự kiện">
                    <div>
                        <div className="row">
                            {Array.isArray(selected_event) &&
                                selected_event.map((event, index) => {
                                    return (
                                        <Tooltip
                                            key={index}
                                            placement="top"
                                            title={event.name}
                                        >
                                            <img
                                                style={{
                                                    height: 64,
                                                    width: 64,
                                                    margin: 3,
                                                    objectFit: 'cover',
                                                    borderRadius: 2,
                                                }}
                                                alt="img"
                                                src={
                                                    event.avatar === ''
                                                        ? defaultEvent
                                                        : event.avatar
                                                }
                                            />
                                        </Tooltip>
                                    )
                                })}
                        </div>
                        <div>
                            <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                icon="select"
                                onClick={() =>
                                    this.props.showModalSelectEvent()
                                }
                            ></Button>
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Đối tượng">
                    <div>
                        <div className="row">
                            {Array.isArray(selected_object) &&
                                selected_object.map((object, index) => {
                                    return (
                                        <Tooltip
                                            key={index}
                                            placement="top"
                                            title={object.name}
                                        >
                                            <img
                                                style={{
                                                    height: 64,
                                                    width: 64,
                                                    margin: 3,
                                                    objectFit: 'cover',
                                                    borderRadius: 2,
                                                }}
                                                alt="img"
                                                src={
                                                    object.avatar !== ''
                                                        ? object.avatar
                                                        : defaulObject
                                                }
                                            />
                                        </Tooltip>
                                    )
                                })}
                        </div>
                        <div>
                            <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                icon="select"
                                onClick={() =>
                                    this.props.showModalSelectObject()
                                }
                            ></Button>
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Tài liệu">
                    <div>
                        <div>
                            {Array.isArray(selected_Media) &&
                                selected_Media.map((media, index) => {
                                    return (
                                        <div key={index}>
                                            <a
                                                rel="noopener noreferrer"
                                                href={media.url}
                                                target="_blank"
                                            >
                                                {media.name}
                                            </a>
                                        </div>
                                    )
                                })}
                        </div>
                        <div>
                            <Button
                                type="primary"
                                shape="circle"
                                size="small"
                                icon="select"
                                onClick={() =>
                                    this.props.showModalSelectMedia()
                                }
                            ></Button>
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Tag">
                    <div>
                        {Array.isArray(hashtag) &&
                            hashtag.map((tag, index) => {
                                return (
                                    <div key={index}>
                                        <Dropdown
                                            overlay={renderDeleteHashTag}
                                            placement="topCenter"
                                            onVisibleChange={visible => {
                                                if (visible)
                                                    this.setState({
                                                        select_hashtag: tag,
                                                    })
                                                else
                                                    this.setState({
                                                        select_hashtag: '',
                                                    })
                                            }}
                                        >
                                            <Tag color="blue">{tag}</Tag>
                                        </Dropdown>
                                    </div>
                                )
                            })}
                        <div>
                            <Popover
                                content={renderMenuHashtag}
                                title="Thêm hashtag"
                                trigger="click"
                                placement="right"
                                visible={this.state.tagMenuVisible}
                                onVisibleChange={
                                    this._handleTagMenuVisibleChange
                                }
                            >
                                <Button
                                    type="primary"
                                    shape="circle"
                                    size="small"
                                    icon="plus"
                                ></Button>
                            </Popover>
                        </div>
                    </div>
                </Form.Item>
                <Form.Item label="Nội dung" hasFeedback>
                    <Editor
                        height={200}
                        value={report.content}
                        onChange={value =>
                            this.props.updateCurentReport({ content: value })
                        }
                    />
                </Form.Item>
                {report.fid !== 0 && (
                    <Form.Item label="Người dùng đã xem">
                        {user_has_read.map((user, index) => {
                            return (
                                <Tooltip placement="rightTop" title={user.display_name}>
                                    <Avatar
                                        src={user.avatar === '' ? defaultAvatar : user.avatar}
                                        alt={user.display_name}
                                        key={index}
                                        style={{ marginRight: 5 }}
                                    />
                                </Tooltip>
                            )
                        })}
                    </Form.Item>
                )}

                {report.fid !== 0 && <ListComment />}

                {/* action */}
                <Form.Item wrapperCol={{ span: 12, offset: 13 }}>
                    <Button
                        size="large"
                        onClick={e => this._handleSendReport()}
                        style={{
                            backgroundColor: '#03c2fc',
                            marginRight: 5,
                            color: 'black',
                        }}
                    // disabled={visible_button_send_report}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Gửi báo cáo
                    </Button>

                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => {
                            this.setState({ fileList: [] })
                            this.props.onCancel()
                        }}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
                <Dialog
                    open={this.state.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">{"Thông báo"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Khi thay đổi thuộc tính Tier các báo căn cứ sẽ bị xoá mất. Bạn có chắc chắn muốn thay đổi tier báo cáo?
          </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMaterial onClick={() => this.handleClose()} color="primary">
                            Không
          </ButtonMaterial>
                        <ButtonMaterial onClick={() => this.handleChangeTierID()} color="primary">
                            Đồng ý
          </ButtonMaterial>
                    </DialogActions>
                </Dialog>
            </Form>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: true,
        selected_Media: state.qbreport.selected_Media,
        selected_object: state.qbreport.selected_object,
        selected_event: state.qbreport.selected_event,
        selected_report: state.qbreport.selected_report,
        hashtag: state.qbreport.hashtag,
        user_has_read: state.qbreport.current_report.user_has_read
            ? state.qbreport.current_report.user_has_read
            : [],
        report: state.qbreport.current_report,
        is_select_report_tier: state.qbreport.is_select_report_tier,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showModalSelectMedia: () => {
            dispatch(ReportActions.action.showModalSelectMedia())
        },
        showModalSelectObject: () => {
            dispatch(ReportActions.action.showModalSelectObject())
        },
        showModalSelectEvent: () => {
            dispatch(ReportActions.action.showModalSelectEvent())
        },
        showModalSelectReportLowerTier: () => {
            dispatch(ReportActions.action.showModalSelectReportLowerTier())
        },
        addHashTag: hashtag => {
            dispatch(ReportActions.action.addHashTag(hashtag))
        },
        deleteHashTag: hashtag => {
            dispatch(ReportActions.action.deleteHashTag(hashtag))
        },
        updateCurentReport: report => {
            dispatch(ReportActions.action.updateCurentReport(report))
        },
        saveCurrentReport: () => {
            dispatch(ReportActions.action.saveCurrentReport())
        },
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalReportInfo())
        },
        sendCurrentReport: () => {
            dispatch(ReportActions.action.sendCurrentReport())
        },
        updateSelectedReport: reports => {
            dispatch(ReportActions.action.updateSelectedReportLowerTier(reports))
        },
    }
}

const WrappedReportInfoForm = Form.create({ name: 'reportinfo' })(
    ReportInfoForm
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrappedReportInfoForm)
